import { ErrorHandler, Injector, Injectable } from '@angular/core';

import { LogService } from '../services/log.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
	private logService: LogService | undefined;

	constructor(private readonly injector: Injector) {}

	handleError(e: unknown) {
		if (!this.logService) {
			this.logService = this.injector.get<LogService | undefined>(LogService);
			if (!this.logService) {
				if (typeof e === 'object' && e && 'rejection' in e) {
					console.error((<{ rejection: unknown }> e).rejection, '\n', e);
				} else {
					console.error(e);
				}
				return;
			}
		}

		this.logService.error(e);
	}
}
